export default __webpack_public_path__ + "static/media/main_page.4d685bc0.jpg";